import API from '../shared/constants'
import { getMovie } from './objects/movie'
import { getSeason } from './objects/season'
import { getPackage } from './objects/package'

/**
 * Get Structured data for rich results
 * @param item
 * @param router
 * @param baseUrl
 * @returns {{}}
 */
export function getStructuredData (item, router, baseUrl) {
  let data = {}

  switch (item.type) {
    case API.RESOURCE_TYPES.VIDEO:
      data = getMovie(item, router, baseUrl)
      break
    case API.RESOURCE_TYPES.SEASON:
      data = getSeason(item, router, baseUrl)
      break
    case API.RESOURCE_TYPES.PACKAGE:
      if (item.videos && item.videos.length > 1) {
        data = getPackage(item, router, baseUrl)
      }
      break
    default:
      data = getMovie(item, router, baseUrl)
      break
  }

  return data
}
